import { render } from "./AppBadges.vue?vue&type=template&id=13442843&scoped=true&ts=true"
import script from "./AppBadges.vue?vue&type=script&lang=ts"
export * from "./AppBadges.vue?vue&type=script&lang=ts"

import "./AppBadges.vue?vue&type=style&index=0&id=13442843&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13442843"]])

export default __exports__